import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import {
	MULTI_SELECT_CF_TYPE,
	ISSUE_FIELD_SINGLE_SELECT_CF_TYPE,
	ISSUE_FIELD_MULTI_SELECT_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import {
	toLegacyConnectOption,
	transformAggConnection,
	transformAggNodeToLegacyField,
} from './default-node-transformer.tsx';

export const transformAggConnectMultipleSelectToLegacyFieldOld: FieldTransformer = (node) => {
	const value = transformAggConnection(node.selectedOptions, toLegacyConnectOption);
	const allowedValues = transformAggConnection(
		node.connectMultiSelectFieldOptions,
		toLegacyConnectOption,
	);

	return {
		...transformAggNodeToLegacyField(node),
		value: value.length ? value : null,
		allowedValues,
		schema: {
			type: ISSUE_FIELD_MULTI_SELECT_CF_TYPE,
			renderer: PLAIN_TEXT,
			custom: node.type,
			system: null,
			items: ISSUE_FIELD_SINGLE_SELECT_CF_TYPE,
			configuration: null,
		},
	};
};

export const transformAggConnectMultipleSelectToLegacyFieldNew: FieldTransformer = (node) => {
	const value = transformAggConnection(node.selectedOptions, (option) => ({
		id: option.optionId,
		value: option.value ?? null,
		ari: option.id,
	}));

	return {
		...transformAggNodeToLegacyField(node),
		value: value.length ? value : null,
		allowedValues: [],
		schema: {
			type: MULTI_SELECT_CF_TYPE,
			renderer: PLAIN_TEXT,
			custom: node.type,
			system: null,
			items: ISSUE_FIELD_SINGLE_SELECT_CF_TYPE,
			configuration: null,
		},
	};
};

export const transformAggConnectMultipleSelectToLegacyField: FieldTransformer = (node) =>
	fg('dfo_remove_connect_multi_select_field_options_agg')
		? transformAggConnectMultipleSelectToLegacyFieldNew(node)
		: transformAggConnectMultipleSelectToLegacyFieldOld(node);
